// Decode only the exp claim; backend signature verification remains authoritative.
export function isJWTExpired(token: string): boolean {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;

    let base64 = parts[1]!.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);

    const payload = JSON.parse(atob(base64)) as { exp?: number };
    if (typeof payload.exp !== 'number') return true;

    return payload.exp <= Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
}
